import React from 'react';

const TermsOfService = () => {
  return (
    <div style={{ padding: '2rem', textAlign: 'left', maxWidth: '800px', margin: '0 auto' }}>
      <h1>Terms of Service</h1>

      <h2>Welcome to NovaHomes</h2>
      <p>
        These Terms of Service ("Terms") govern your access to and use of the NovaHomes website,
        mobile application, and any related services provided by NovaHomes (collectively referred
        to as the "Platform"). By accessing or using the Platform, you agree to comply with these
        Terms. If you do not agree to these Terms, you must refrain from using the Platform.
      </p>

      <h2>1. Acceptance of Terms</h2>
      <p>
        By accessing or using the Platform, you represent that you are at least 18 years old or the
        legal age of majority in your jurisdiction, whichever is higher. You also affirm that you
        have the legal capacity to enter into a binding agreement. If you are using the Platform on
        behalf of an organization or entity, you represent that you have the authority to bind that
        entity to these Terms.
      </p>
      <p>
        NovaHomes reserves the right to modify, update, or amend these Terms at any time without
        prior notice. Your continued use of the Platform after such changes constitutes your
        acceptance of the revised Terms. It is your responsibility to review these Terms periodically
        for updates.
      </p>

      <h2>2. Use of the Platform</h2>
      <p>
        The Platform provides users with access to real estate information, property details, maps,
        and other related services. You may use the Platform solely for lawful purposes and in
        accordance with these Terms. You agree not to:
      </p>
      <ul>
        <li>Engage in any activity that violates applicable laws, regulations, or third-party rights.</li>
        <li>Use the Platform to distribute spam, malware, or other harmful content.</li>
        <li>Attempt to gain unauthorized access to the Platform or its systems.</li>
        <li>Reverse engineer, decompile, or otherwise attempt to extract the source code of the Platform.</li>
        <li>Use automated tools or scripts to scrape data from the Platform.</li>
      </ul>

      <h2>3. Intellectual Property</h2>
      <p>
        All content available on the Platform, including but not limited to text, images, logos,
        graphics, videos, and software, is the intellectual property of NovaHomes or its licensors.
        These materials are protected by copyright, trademark, and other intellectual property laws.
      </p>
      <p>
        You may view and download content from the Platform for personal, non-commercial use only.
        Any reproduction, distribution, modification, or public display of the content without
        explicit written permission from NovaHomes is strictly prohibited.
      </p>

      <h2>4. User Accounts</h2>
      <p>
        To access certain features of the Platform, you may be required to create an account. You
        are responsible for maintaining the confidentiality of your account credentials and for all
        activities that occur under your account. You agree to notify NovaHomes immediately of any
        unauthorized use of your account or any other security breaches.
      </p>
      <p>
        NovaHomes reserves the right to suspend or terminate your account at any time, with or
        without cause, and without prior notice. Grounds for termination may include, but are not
        limited to, violations of these Terms, fraudulent activity, or disruptive behavior.
      </p>

      <h2>5. Third-Party Links and Content</h2>
      <p>
        The Platform may contain links to third-party websites, advertisements, or resources. These
        links are provided for your convenience and do not imply endorsement by NovaHomes. We are
        not responsible for the availability, accuracy, or content of any third-party sites or
        services. Your interactions with third parties, including advertisers, are solely between
        you and the third party.
      </p>

      <h2>6. Disclaimers</h2>
      <p>
        The Platform is provided "as is" and "as available" without warranties of any kind, either
        express or implied. NovaHomes does not guarantee that the Platform will be error-free,
        uninterrupted, or free from viruses or other harmful components. While we strive to ensure
        the accuracy and reliability of the information provided, NovaHomes makes no representations
        or warranties regarding the completeness, accuracy, or timeliness of the content.
      </p>

      <h2>7. Limitation of Liability</h2>
      <p>
        To the fullest extent permitted by law, NovaHomes and its affiliates, officers, employees,
        agents, and licensors shall not be liable for any indirect, incidental, special,
        consequential, or punitive damages arising out of or related to your use of the Platform.
        This includes, but is not limited to, damages for loss of profits, goodwill, data, or other
        intangible losses.
      </p>
      <p>
        In no event shall NovaHomes' total liability for any claims arising out of or related to
        your use of the Platform exceed the amount you paid to NovaHomes, if any, during the twelve
        months preceding the claim.
      </p>

      <h2>8. Indemnification</h2>
      <p>
        You agree to indemnify and hold harmless NovaHomes, its affiliates, officers, employees,
        agents, and licensors from and against any claims, liabilities, damages, losses, costs, or
        expenses (including reasonable attorneys' fees) arising out of or related to your use of
        the Platform, your violation of these Terms, or your infringement of any third-party rights.
      </p>

      <h2>9. Governing Law and Jurisdiction</h2>
      <p>
        These Terms shall be governed by and construed in accordance with the laws of [Your
        Jurisdiction], without regard to its conflict of law principles. Any disputes arising out
        of or related to these Terms shall be resolved exclusively in the courts of [Your
        Jurisdiction].
      </p>

      <h2>10. Severability</h2>
      <p>
        If any provision of these Terms is found to be invalid or unenforceable, the remaining
        provisions shall remain in full force and effect.
      </p>

      <h2>11. Contact Us</h2>
      <p>
        If you have any questions or concerns about these Terms, please contact us at [Contact
        Information].
      </p>
    </div>
  );
};

export default TermsOfService;